<div class="row fields-group row-content" *ngIf="!parentDeterminantFieldKey && fields.length > 0">
  <div class="col">
    <label class="input-label w-100 field-required"> <span>{{
        'Select field' | translate }}</span>
    </label>
    <search-select (change)="onTargetFormFieldKeyChange($event)" [items]="fields"
      [selected]="isFromGrid && selectedField && isFirstLevel ? selectedField.key : targetFormFieldKey"
      [placeholder]="'Choose here' | translate"></search-select>
  </div>
</div>
<!-- Button determinant - no UI needed, just marks button field is selected -->
<button-determinant *ngIf="buttonEventName !== undefined" [serviceId]="serviceId" [buttonEventName]="buttonEventName"
  [buttonKey]="buttonKey" (buttonEventNameResponse)="buttonEventNameChanged($event)"
  (buttonKeyResponse)="buttonKeyChanged($event)">
</button-determinant>
<!-- File Upload Event Determinant -->
<file-upload-determinant *ngIf="fileUploadEventName !== undefined" [serviceId]="serviceId"
  [fileUploadEventName]="fileUploadEventName" [fileUploadKey]="fileUploadKey"
  (fileUploadEventNameResponse)="fileUploadEventNameChanged($event)"
  (fileUploadKeyResponse)="fileUploadKeyChanged($event)">
</file-upload-determinant>
<!-- Grid Component Event Determinant -->
<grid-component-determinant *ngIf="gridEventName !== undefined" [serviceId]="serviceId" [gridEventName]="gridEventName"
  [gridKey]="gridKey" (gridEventNameResponse)="gridEventNameChanged($event)" (gridKeyResponse)="gridKeyChanged($event)">
</grid-component-determinant>
<div class="row fields-group row-content"
  *ngIf="(getFieldType() === 'GRID' || isFromGrid) && buttonEventName === undefined && fileUploadEventName === undefined && gridEventName === undefined">
  <div class="col">
    <label class="input-label w-100 field-required"> <span>{{ 'where will the determinant be applied' | translate
        }}</span>
    </label>
    <select class="form-control" [(ngModel)]="gridContext" (ngModelChange)="contextChanged($event)">>
      <option *ngFor="let s of gridContexts" [selected]="gridContext == s" value="{{s}}">{{ s | translate }}</option>
    </select>
  </div>
</div>
<div class="row fields-group"
  *ngIf="(getFieldType() === 'GRID' || isFromGrid) && gridContext === 'outside the grid' && buttonEventName === undefined && fileUploadEventName === undefined && gridEventName === undefined">
  <div class="col">
    <label class="input-label w-100 field-required"> <span>{{
        'For which rows' | translate }}</span>
    </label>
    <select class="form-control" [(ngModel)]="subject" (ngModelChange)="subjectChanged($event)">
      <option *ngFor="let s of getGridSubjects()" [selected]="subject == s">{{ s | translate }}</option>
    </select>
  </div>
</div>
<ng-container
  *ngIf="getFieldType() !== 'GRID' && !isFromGrid && (selectedField || targetFormFieldKey) && buttonEventName === undefined && fileUploadEventName === undefined && gridEventName === undefined">
  <ng-container [ngSwitch]="currentChildComponentType">
    <boolean-determinant *ngSwitchCase="'BOOLEAN'" (booleanValueResponse)="booleanValueChanged($event)"
      [booleanValue]="booleanValue" [fields]="fields" [sourceFormFieldKey]="sourceFormFieldKey">
    </boolean-determinant>
    <numeric-determinant *ngSwitchCase="'NUMERIC'" [operator]="operator" (operatorResponse)="operatorChanged($event)"
      [numericValue]="numericValue" [fields]="fields" [isTargetComponent]="isFormComponent()"
      [sourceFormFieldKey]="sourceFormFieldKey" (numericValueResponse)="numericValueChanged($event)">
    </numeric-determinant>
    <money-determinant *ngSwitchCase="'MONEY'" [operator]="operator" (operatorResponse)="operatorChanged($event)"
      [moneyValue]="moneyValue" [fields]="fields" [sourceFormFieldKey]="sourceFormFieldKey"
      (moneyValueResponse)="moneyValueChanged($event)">
    </money-determinant>
    <text-determinant *ngSwitchCase="'TEXT'" [operator]="textOperator" (operatorResponse)="textOperatorChanged($event)"
      [isTargetComponent]="isFormComponent()" [textValue]="textValue" [fields]="fields"
      [sourceFormFieldKey]="sourceFormFieldKey" [multiple]="isCatalogMultiple || false"
      [selectedField]="determinant.targetFormFieldKey" (textValueResponse)="textValueChanged($event)">
    </text-determinant>
    <file-determinant *ngSwitchCase="'FILE'" [isTargetComponent]="isFormComponent()" [operator]="textOperator"
      (operatorResponse)="textOperatorChanged($event)">
    </file-determinant>
    <date-determinant *ngSwitchCase="'DATE'" [operator]="operator" [isTargetComponent]="isFormComponent()"
      (operatorResponse)="operatorChanged($event)" [dateValue]="dateValue" [isCurrentDate]="isCurrentDate"
      [fields]="fields" [sourceFormFieldKey]="sourceFormFieldKey" (isCurrentDateResponse)="isCurrentDateChanged($event)"
      (dateValueResponse)="dateValueChanged($event)">
    </date-determinant>
    <select-determinant *ngSwitchCase="'SELECT'" [isTargetComponent]="isFormComponent()" [fieldType]="type"
      [operator]="selectOperator" (operatorResponse)="selectOperatorChanged($event)" [selectValue]="selectValue"
      [fields]="fields" [sourceFormFieldKey]="sourceFormFieldKey" (selectValueResponse)="selectValueChanged($event)"
      [selections]="fieldSelectionValues"> </select-determinant>
    <catalog-determinant *ngSwitchCase="'CATALOG'" [operator]="classificationOperator"
      [isTargetComponent]="isFormComponent()" (operatorResponse)="classificationOperatorChanged($event)"
      [catalogFieldValue]="classificationValue" [fields]="fields" [subject]="subject"
      [type]="getFieldType(selectedField)" [classificationFields]="classificationFields"
      [isCatalogMultiple]="isCatalogMultiple" (subjectResponse)="subjectChanged($event)"
      [targetFormFieldKey]="targetFormFieldKey" [gdbCatalog]="gdbCatalog" [sourceFormFieldKey]="sourceFormFieldKey"
      [determinantType]="determinantType"
      [catalogFieldValueId]="(determinant.classificationField && determinant.classificationField.id) || determinant.gdbCatalogSelectedValue"
      (catalogValueResponse)="catalogValueChanged($event)" (catalogGroupValueChanged)="catalogGroupValueChanged($event)"
      (changeClassificationFields)="updateClassificationFields($event)" [catalogGroupFields]="fieldSelectionValues"
      [catalogGroupValue]="classificationGroup && classificationGroup.id"
      [catalogId]="!parentClassificationTypeId && fieldClassificationTypeId"
      [parentCatalogTypeId]="parentCatalogValue ? parentCatalogValue.id : parentClassificationTypeId">
    </catalog-determinant>
    <sub-catalog-determinant *ngSwitchCase="'SUB_CATALOG'" [operator]="classificationOperator"
      (operatorResponse)="classificationOperatorChanged($event)" [fields]="fields" [subject]="subject"
      [isCatalogMultiple]="isCatalogMultiple" [isTargetComponent]="isFormComponent()"
      [classificationFields]="classificationFields" (changeClassificationFields)="updateClassificationFields($event)"
      [sourceFormFieldKey]="sourceFormFieldKey" (subjectResponse)="subjectChanged($event)"
      (catalogValueResponse)="catalogValueChanged($event)" [parentCatalogFieldValue]="parentCatalogValue"
      (parentCatalogValueResponse)="parentCatalogValueChanged($event)" [parentCatalogId]="parentClassificationTypeId"
      [subCatalogFieldValue]="subCatalogValue ? subCatalogValue.id : null"
      (subCatalogValueResponse)="subCatalogValueChanged($event)"
      [subCatalogId]="parentCatalogValue && parentCatalogValue.childClassificationType ? parentCatalogValue.childClassificationType.id : null">
    </sub-catalog-determinant>
  </ng-container>
  <ng-container *ngIf="determinantType == 'BOT' && determinant">
    <validation-determinant (booleanValueResponse)="booleanValueChanged($event)"
      [booleanValue]="determinant.valid"></validation-determinant>
  </ng-container>
</ng-container>
<formfield-determinant *ngIf="isFromGrid && gridContext && rowDeterminant" [serviceId]="serviceId"
  [determinant]="rowDeterminant" [name]="name" [isFirstLevel]="false" [fieldSelectionValues]="fieldSelectionValues"
  [parentDeterminantFieldKey]="targetFormFieldKey" [targetFormFieldKey]="targetFormFieldKey"
  [fieldClassificationTypeId]="fieldClassificationTypeId" [selectedField]="selectedField" [fields]="fields"
  [allFields]="allFields" (determinantResponse)="rowDeterminantChanged($event)"></formfield-determinant>